import React, { useCallback, useEffect, useState } from "react";
import { useSnackbar, VariantType } from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface IConfig {
  message: string;
  variant: VariantType;
}
//TODO: Добавить showConfirm():boolean
export const useNotification = () => {
  const [conf, setConf] = useState<IConfig>({} as IConfig);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = useCallback(
    (key: any) => (
      <IconButton
        onClick={() => {
          closeSnackbar(key);
        }}
      >
        <CloseOutlinedIcon />
      </IconButton>
    ),
    [closeSnackbar]
  );

  useEffect(() => {
    if (conf.message) {
        enqueueSnackbar(<div style={{ maxWidth: 500 }}>{conf.message}</div>, {
        variant: conf.variant ?? "info",
        autoHideDuration: 5000,
        action,
      });
    }
  }, [conf, action, enqueueSnackbar]);

  const showNotify = useCallback((message: string, variant: VariantType) => {
    setConf({ message, variant });
  }, []);

  return { showNotify };
};
